var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colorpicker"},[_c('section',{staticClass:"controls"},[_c('Saturation',{attrs:{"value":_vm.colors},on:{"change":_vm.handleSaturationChange}}),_c('div',{staticClass:"control"},[_c('input',{style:(_vm.gradientH),attrs:{"type":"range","min":"0","max":"360"},domProps:{"value":_vm.h},on:{"input":_vm.handleHueChange}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }